module.exports = __webpack_public_path__ + "static/media/wave-10.a8b795a4.svg";